import React, { useCallback, useMemo, useState } from 'react';

import ShareSlideOverInfoContainer from './container';
import ShareSlideOverAdditionalLinksInfo from './additional-links.panel';
import ShareSlideOverChromeExtensionInfo from './chrome-extension.panel';
import { getLocalKey, setLocalKey } from 'src/common/helpers/browser-cache';

export const SHARE_SLIDE_OVER_INFO_BANNER_SEEN_KEY = 'share-slide-over-info-banner-seen';

interface Props {
  linkCount: number;
}

const ShareSlideOverInfoBanner = ({ linkCount }: Props) => {
  const [dismissed, setDismissed] = useState(false);

  const isVisible = useMemo(() => {
    const seenKey = getLocalKey(SHARE_SLIDE_OVER_INFO_BANNER_SEEN_KEY);
    return (!seenKey && !dismissed) || linkCount < 2;
  }, [dismissed, linkCount]);

  const dismissNotification = () => {
    setLocalKey(SHARE_SLIDE_OVER_INFO_BANNER_SEEN_KEY, 'true');
    setDismissed(true);
  };

  if (!isVisible) return null;

  return (
    <ShareSlideOverInfoContainer>
      {linkCount < 2 ? (
        <ShareSlideOverAdditionalLinksInfo />
      ) : (
        <ShareSlideOverChromeExtensionInfo onDismiss={dismissNotification} />
      )}
    </ShareSlideOverInfoContainer>
  );
};

export default ShareSlideOverInfoBanner;
